module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.c19c88e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/Roboto-Medium.woff2
// module id = 8S68
// module chunks = 0